import { Component, inject, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../shared/auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  isLoading = false;
  userType = 'client';

  mask = '000 000-00-00';
  countryCode: string = '7';
  timerIsActive = false;
  codeSent = false;
  readonly dialog = inject(MatDialog);

  phoneForm = new FormGroup({
    phone: new FormControl('', [Validators.required]),
  });

  loginForm = new FormGroup({
    phone: new FormControl('', [Validators.required]),
    code: new FormControl('', [Validators.required]),
    userType: new FormControl(this.userType, [Validators.required]),
  });

  ngOnInit(): void {
    if (this.authService.isLoggedIn) {
      this.router.navigate(['cabinet']);
    }
  }

  onPhoneSend() {
    if (this.phoneForm.valid) {
      const value = this.phoneForm.value;
      const phone = `${this.countryCode}${value.phone}`;
      this.isLoading = true;
      this.codeSent = true;
      this.loginForm.controls.phone.patchValue(phone);

      if (this.phoneForm.valid) {
        this.authService.register(phone).subscribe((res) => {
          if (res.hasOwnProperty('status') && res.status === 'ok') {
            this.timerIsActive = true;
            this.isLoading = false;
          } else {
            console.log('Ошибка при отправке кода');
          }
        });
      }
    }
  }

  enableLimits() {
    this.timerIsActive = false;
    this.loginForm.controls.code.reset();
    this.loginForm.controls.phone.reset();
    this.codeSent = false;
  }

  onCodeSend() {
    if (this.loginForm.valid) {
      this.isLoading = true;


      // if (this.authService.login(this.loginForm.get('phone')?.value ?? '', this.loginForm.get('code')?.value ?? '')) {
      //   this.codeSent = false;
      //   this.router.navigate(['/cabinet']);
      //   this.isLoading = false;
      // }
      //
      this.authService.login(this.loginForm.get('phone')?.value ?? '', this.loginForm.get('code')?.value ?? '').subscribe((_) => {
        this.codeSent = false;
        this.router.navigate(['/cabinet']);
        this.isLoading = false;
      });
    }
  }

  onKeyUp(event: KeyboardEvent, target: string) {
    if (event.code === 'Enter') {
      if (target === 'phone') {
        this.onPhoneSend();
      } else if (target === 'code') {
        this.onCodeSend();
      }
    }
  }

  switchUserType(userType: string) {
    this.loginForm.controls.userType.patchValue(userType);
    this.userType = userType;
  }
}
